export const environment = {
  api_redsys: 'https://dev.pizzaencasa.com',
  url: 'https://dev.pizzaencasa.com/api/',
  backend_url: 'https://pizzaencasa.com/api/',
  GOOGLE_ID: '',
};
